export default __webpack_public_path__ + "static/VilaSuica-c7b7086f62e06906cec44e4c9c59d305.svg";